import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FAQ } from "@/content";
import { Plus, Minus } from "lucide-react";

export default function FAQSection() {
  const [open, setOpen] = useState(0);
  return (
    <section
      id="faq"
      data-testid="section-faq"
      className="relative py-24 lg:py-32 bg-[#EFEADB]"
    >
      <div className="max-w-5xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center mb-14"
        >
          <span
            className="block text-xs text-brand-accent mb-5"
          >
            أسئلة شائعة
          </span>
          <h2 className="text-4xl sm:text-5xl text-brand-ink mb-3 leading-tight">
            إجابات تساعدك على القرار
          </h2>
        </motion.div>

        <div className="space-y-3" data-testid="faq-list">
          {FAQ.map((item, i) => {
            const isOpen = open === i;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                className="bg-brand-cream border border-brand-border rounded-2xl overflow-hidden"
                data-testid={`faq-item-${i}`}
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full px-6 py-5 lg:px-8 lg:py-6 flex items-center justify-between gap-4 text-right"
                  data-testid={`faq-toggle-${i}`}
                >
                  <span className="text-base lg:text-lg text-brand-ink font-medium flex-1">
                    {item.q}
                  </span>
                  <span className={`inline-flex items-center justify-center w-9 h-9 rounded-full transition-colors ${isOpen ? "bg-brand-olive text-brand-cream" : "bg-brand-olive/10 text-brand-olive"}`}>
                    {isOpen ? <Minus size={16} /> : <Plus size={16} />}
                  </span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.35 }}
                      className="overflow-hidden"
                    >
                      <div className="px-6 pb-6 lg:px-8 lg:pb-7 text-brand-mute leading-loose border-t border-brand-border/60 pt-5">
                        {item.a}
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

